// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HI5y","content":"styles_content__1KTNU"};